<template>
  <Multiselect
    ref="test"
    v-model="value"
    class="districts"
    track-by="id"
    label="name"
    :placeholder="i18n.placeholder"
    :options="options"
    :loading="loading"
    :multiple="true"
  >
    <template #noResult>
      <span class="multiselect__noresult">
        {{ i18n.noResults }}
      </span>
    </template>
  </Multiselect>
</template>

<script>
import includes from 'lodash/includes';
import Multiselect from 'vue-multiselect';
import Api from '../js/modules/api';

export default {
  name: 'DistrictSelect',
  components: {
    Multiselect,
  },
  props: {
    i18n: {
      type: Object,
      required: true,
      validator(data) {
        const requiredProps = [
          'placeholder',
          'noResults',
        ];

        return Object.keys(data)
          .filter((key) => includes(requiredProps, key)).length === requiredProps.length;
      },
    },
    selectedDistricts: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      options: [],
      loading: true,
      value: [],
    };
  },
  watch: {
    value(value) {
      this.$emit('change', value);
    },
  },
  created() {
    const api = Api();

    api.getDistricts()
      .then((data) => {
        this.options = data;

        if (this.selectedDistricts === '') {
          return;
        }
        if (Number.isInteger(this.selectedDistricts)) {
          this.handleSelectedDistricts(data, this.selectedDistricts);
          return;
        }
        this.selectedDistricts.split(',').map((selectedDistrict) => (
          this.handleSelectedDistricts(data, selectedDistrict)
        ));
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    handleSelectedDistricts(data, selectedDistrict) {
      data.forEach((district) => {
        if (Number(district.id) === Number(selectedDistrict)) {
          this.value.push(district);
        }
      });
    },
  },
};
</script>
